import { ButtonColorOption, ButtonShape, ButtonSize, ButtonVariant } from "./button.types";

export const BUTTON_DEFAULT_COLOR: ButtonColorOption = "interactive";

export const BUTTON_DEFAULT_SHAPE: ButtonShape = "rounded";

export const BUTTON_DEFAULT_SIZE: ButtonSize = "large";

export const BUTTON_DEFAULT_VARIANT: ButtonVariant = "filled";
